var render, staticRenderFns
import script from "./eb-button-list.vue?vue&type=script&lang=js&"
export * from "./eb-button-list.vue?vue&type=script&lang=js&"
import style0 from "./eb-button-list.vue?vue&type=style&index=0&id=253acf87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253acf87",
  null
  
)

export default component.exports